<template>
    <div class="Dashboard">
        <el-card class="card-item" v-if="data.countArticle">
            <div slot="header" class="clearfix">
                <span>文章统计</span>
            </div>
            <el-row :gutter="20">
                <el-col :span="6">
                    <p>个人会员文章</p>
                    <span>{{ data.countArticle.grCount }}</span>
                </el-col>
                <el-col :span="6">
                    <p>单位会员文章</p>
                    <span>{{ data.countArticle.qyCount }}</span>
                </el-col>
                <el-col :span="6">
                    <p>待审核文章</p>
                    <span>{{ data.countArticle.paddingCount }}</span>
                </el-col>
                <el-col :span="6">
                    <p>文章总数</p>
                    <span>{{ data.countArticle.totalCount }}</span>
                </el-col>
            </el-row>
        </el-card>

        <el-card class="card-item" v-if="data.countUser">
            <div slot="header" class="clearfix">
                <span>会员统计</span>
            </div>
            <el-row :gutter="20">
                <el-col :span="6">
                    <p>个人会员</p>
                    <span>{{ data.countUser.grCount }}</span>
                </el-col>
                <el-col :span="6">
                    <p>单位会员</p>
                    <span>{{ data.countUser.qyCount }}</span>
                </el-col>
                <el-col :span="6">
                    <p>待审核个人会员</p>
                    <span>{{ data.countUser.grPaddingCount }}</span>
                </el-col>
                <el-col :span="6">
                    <p>待审核单位会员</p>
                    <span>{{ data.countUser.qyPaddingCount }}</span>
                </el-col>
            </el-row>
        </el-card>

        <el-card class="card-item" v-if="data.countArticlesOfCat">
            <div slot="header" class="clearfix">
                <span>栏目文章统计</span>
            </div>
            <el-row :gutter="20" v-for="(item, index) in data.countArticlesOfCat" :key="index">
                <div style="font-weight:bold;color: #409EFF;text-align: left;margin-left: 10px;">{{ item.catName }}</div>
                <el-col :span="6">
                    <p>审核通过</p>
                    <span>{{ item.passedCount }}</span>
                </el-col>
                <el-col :span="6">
                    <p>待审核</p>
                    <span>{{ item.paddingCount }}</span>
                </el-col>
                <el-col :span="6">
                    <p>审核不通过</p>
                    <span>{{ item.failCount }}</span>
                </el-col>
                <el-col :span="6">
                    <p>文章总数</p>
                    <span>{{ item.totalCount }}</span>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            data: {}
        }
    },
    created() {
        this.init()
    },
    methods: {
        init() {
            this.$https.get(this.$api.dashboardData).then(res => {
                this.data = res
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.Dashboard {
    position: relative;

    .card-item {
        margin-bottom: 20px;
        text-align: center;

        .clearfix {
            text-align: left;
        }

        span {
            font-size: 20px;
            font-weight: bold;
        }
    }
}
</style>